import React, { useState, useEffect } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import FadeLoader from "react-spinners/FadeLoader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  customer_reset_password_request,
  customer_reset_password_confirm,
} from "../store/reducers/authReducer";

const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.auth);
  const [resetStep, setResetStep] = useState("email");
  const [resetData, setResetData] = useState({
    email: "",
    otp: "",
    newPassword: "",
  });
  const [timeLeft, setTimeLeft] = useState(180); // 3 minutes in seconds

  // Format time as MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${minutes}:${secs} min`;
  };

  // Timer logic
  useEffect(() => {
    if (resetStep === "newPassword" && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup on unmount or step change
    } else if (timeLeft === 0) {
      toast.error(
        "Time out, failed to reset password -  انتهت المهلة، فشل في إعادة تعيين كلمة المرور"
      );
      navigate("/login"); // Redirect when timer hits 0
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }, [resetStep, timeLeft, navigate]);

  const resetInputHandle = (e) => {
    setResetData({ ...resetData, [e.target.name]: e.target.value });
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    dispatch(customer_reset_password_request(resetData.email))
      .unwrap()
      .then((response) => {
        toast.success(response.message);
        setResetStep("newPassword");
        setTimeLeft(1800); // Reset timer to 3 minutes
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    dispatch(customer_reset_password_confirm({ ...resetData }))
      .unwrap()
      .then((response) => {
        toast.success(response.message);
        localStorage.clear();
        navigate("/login");
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const navigateToLogin = () => {
    navigate("/login");
    window.location.reload();
  };

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <div
        className=" bg-cover bg-no-repeat relative bg-left"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/rBg.jpg)`,
        }}
      >
        <Headers />
        <div className="w-full justify-center items-center py-10 mt-5">
          <div className="grid grid-cols-2 lg:block w-[60%] md:w-[95%] mx-auto bg-[#ffffffb8] rounded-md backdrop-blur-md border-t-4 border-mainColor">
            <div className="px-8 py-16">
              <h2
                className="text-2xl mb-4 text-center gradient-t0"
                style={{ textShadow: "-2px 2px 5px #00022e43" }}
              >
                إعادة تعيين كلمة المرور
              </h2>

              <div className="bg-slate-50 p-6 rounded-lg shadow-inner">
                {resetStep === "email" && (
                  <form onSubmit={handleEmailSubmit}>
                    <div>
                      <div className="flex flex-col justify-center mb-8 text-xs text-red-400 text-center">
                        <p>
                          يرجى استخدام بريدك الإلكتروني لاستلام الكود لإعادة
                          تعيين كلمة مرورك
                        </p>
                        <p>
                          بعد إتمام عملية الإرسال، يُرجى مراجعة بريدك الإلكتروني
                          للعثور على الكود المكون من 6 أرقام
                        </p>
                      </div>
                    </div>
                    <div className="mb-4">
                      <label className="block mb-1">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={resetData.email}
                        onChange={resetInputHandle}
                        className="w-full px-3 py-2 border rounded-md"
                        placeholder="Enter your email"
                        required
                      />
                    </div>
                    <div className="flex justify-between">
                      <button
                        type="button"
                        className="second-btn"
                        onClick={navigateToLogin}
                      >
                        Annuler - إلغاء
                      </button>
                      <button
                        type="submit"
                        className="main-btn2"
                        disabled={loader}
                      >
                        {loader ? "Sending..." : "OTP - ارسال الكود"}
                      </button>
                    </div>
                  </form>
                )}

                {resetStep === "newPassword" && (
                  <form onSubmit={handleOtpSubmit}>
                    <div className="flex flex-col justify-center mb-8 text-xs text-red-400 text-center">
                      <p>
                        يرجى التحقق من صندوق بريدك الإلكتروني للعثور على الكود
                      </p>
                      <p>إذا لم تجده، فيرجى التحقق من صندوق البريد العشوائي</p>
                      <p className="text-green-500 mt-2">
                        Temps restant :{" "}
                        <span className="font-bold text-sm">
                          {formatTime(timeLeft)}
                        </span>{" "}
                        : الوقت المتبقي
                      </p>
                    </div>
                    <div className="mb-4">
                      <label className="block mb-1">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={resetData.email}
                        onChange={resetInputHandle}
                        className="w-full px-3 py-2 border rounded-md"
                        placeholder={resetData.email}
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-1">OTP</label>
                      <input
                        type="text"
                        name="otp"
                        value={resetData.otp}
                        onChange={resetInputHandle}
                        className="w-full px-3 py-2 border rounded-md"
                        placeholder="Enter OTP"
                        required
                      />
                    </div>
                    <div className="mb-4">
                      <label className="block mb-1">
                        Nouveau mot de passe - كلمة المرور الجديدة
                      </label>
                      <p className="text-xs text-green-500 text-center pb-1">
                        يجب أن تتكون كلمة المرور من 8 أحرف على الأقل وتتضمن
                        الأحرف والأرقام
                      </p>
                      <input
                        type="password"
                        name="newPassword"
                        value={resetData.newPassword}
                        onChange={resetInputHandle}
                        className="w-full px-3 py-2 border rounded-md"
                        placeholder="Enter new password"
                        pattern="(?=.*\d)(?=.*[a-zA-Z]).{8,}"
                        title="يجب أن تتكون كلمة المرور من 8 أحرف على الأقل وتتضمن الأحرف والأرقام"
                        required
                      />
                    </div>
                    <div className="flex justify-between">
                      <button
                        type="button"
                        className="second-btn mr-2"
                        onClick={navigateToLogin}
                      >
                        Annuler - إلغاء
                      </button>
                      <button
                        type="submit"
                        className="main-btn2"
                        disabled={loader}
                      >
                        {loader ? "Verifying..." : "Réinitialiser - إعادة ضبط"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
            <div
              className="w-full lg:w-0 lg:hidden bg-cover bg-no-repeat bg-center rounded-r-md "
              style={{
                backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/loginBg.jpg)`,
              }}
            ></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
